import { ForexStatus } from "@/feature/Forex/api/history/forex-history.interface";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export enum PaymentOrderType {
	UZS = 'UZS',
	SWIFT = 'SWIFT',
}

export enum PaymentOrderField {
	PAYMENTS = 'PAYMENTS',
}

export interface PaymentOrderCountDTO {
	status?: ForexStatus | null
	count?: number | null
}

export interface ForexToApproveCountDTO {
	all?: number | null
	buy?: number | null
	sell?: number | null
}

export type ForexToApproveCount = {
	[P in ForexOperationType]: number
}

export type PaymentOrderCount = {
	[P in PaymentOrderType]: number
}